<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3
        mx-0
      "
    >
      <v-row justify="center" class="ma-0 pa-0">
        <v-col
          cols="11"
          xs="11"
          sm="11"
          md="12"
          lg="12"
          xl="12"
          class="ma-0 pa-0"
        >
          <h2 class="texto-titulo text-center font-weight-bold">
            Actualiza el monto de tu crédito
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="9" class="ma-0 mb-0" style="position: relative">
          <v-row justify="center">
            <v-col cols="12" class="d-flex flex-row justify-center">
              <div class="monto-background"></div>
            </v-col>
          </v-row>
          <v-row justify="center" class="ma-0 pa-0">
            <v-col cols="12" class="my-2 pa-0">
              <v-row>
                <v-col cols="12">
                  <v-card class="monto-contenido rounded-xl ma-0 py-1 px-2">
                    <v-card-text class="ma-0 pa-0 text-center">
                      <label
                        for="monto"
                        class="text-caption font-weight-bold"
                        :class="{
                          'orange--text': esMontoSujetoAprobar,
                          'red--text': esMontoInputInvalido,
                          'grey--text text--darken-2':
                            !esMontoInputInvalido && !esMontoSujetoAprobar,
                        }"
                        >{{
                          esMontoInputInvalido || esMontoSujetoAprobar
                            ? montoInputError
                            : '¿Cuánto dinero necesitas?'
                        }}</label
                      ><br />
                      <div
                        class="d-flex flex-row justify-center align-center"
                        @keyup="cambiaMontoInput()"
                      >
                        <v-icon
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          size="20"
                        >
                          mdi-currency-usd
                        </v-icon>
                        <money
                          :v-focus="moneyInputFocus"
                          v-model="montoInput"
                          v-bind="money"
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          class="font-weight-bold monto-input"
                        ></money>
                        <v-icon
                          :class="{
                            'red--text': esMontoInputInvalido,
                            'primary--text': !esMontoInputInvalido,
                          }"
                          size="20"
                          @click="focusInputMoney"
                        >
                          mdi-braille
                        </v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row justify="center">
      <v-col cols="10">
        <v-slider
          v-model="credito.monto.val"
          step="100"
          :min="montoMinimo"
          :max="credito.monto.max"
          track-color="#ccc"
          class="slider-monto"
          hide-details="auto"
          @end="endChange"
        ></v-slider>
        <div class="d-flex flex-row justify-space-between">
          <v-btn x-small text color="grey" @click="seleccionarMontoMinimo"
            >Mínimo<br />{{ montoMoneda(montoMinimo) }}</v-btn
          >
          <v-btn x-small text color="grey" @click="seleccionarMontoMaximo"
            >Máximo<br />{{ montoMoneda(credito.monto.max) }}</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <!-- isra plazos -->
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-7 mt-xs-7 mt-sm-7 mt-md-5 mt-lg-5 mt-xl-5"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <v-select
          v-model="plazoSeleccionado"
          item-text="name"
          item-value="val"
          :items="platzos"
          label="Plazo"
          hide-details="auto"
          outlined
          @change="cambiaMontoInput"
        ></v-select>
      </v-col>
    </v-row>
    <v-row
      v-if="$store.getters['credito/obtenerObservacionesDevolucion'] != ''"
      justify="center"
      class="ma-0 pa-0 mx-3 mt-3"
    >
      <v-col cols="12" class="ma-0 pa-0">
        <v-alert
          dense
          text
          type="info"
          :icon="false"
          class="text-center font-weight-black ma-0"
        >
          <p>Observaciones:</p>
          <p>
            {{ $store.getters['credito/obtenerObservacionesDevolucion'] }}
          </p>
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <v-alert
          dense
          text
          type="info"
          :icon="false"
          class="text-center font-weight-black ma-0"
        >
          <template v-if="!cargando">
            Tu pago {{ credito.frecuenciaSeleccionada.val.toLowerCase() }} es
            de: {{ montoMoneda(credito.montoPago.val) }}
          </template>
          <v-progress-circular
            v-else
            indeterminate
            color="info"
            :width="3"
          ></v-progress-circular>
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="ma-0 pa-0 mt-5 mt-xs-5 mt-sm-5 mt-md-3 mt-lg-3 mt-xl-3"
    >
      <v-col cols="10" class="ma-0 pa-0">
        <p class="text-caption text-center font-weight-bold ma-0 pa-0">
          Oferta válida por tiempo limitado <br />
          La mejor tasa en créditos digitales: <br />
          <v-icon
            justify="center"
            class="text-xs-center"
            slot="icon"
            color="error"
            size="20"
            fab
          >
            mdi-sale
          </v-icon>
          Tasa mensual: {{ credito.tasa.val }}%
        </p>
        <!-- <v-banner
          class="mb-5"
          elevation="5"
          outlined
          rounded
          single-line
          shaped
        >
          <p class="text-center grey--text text--darken-2 ma-0 pa-0">
            Oferta válida por tiempo limitado <br />
          </p>
          <v-icon slot="icon" color="error" size="36"> mdi-sale </v-icon>
          <p class="text-center grey--text text--darken-2 ma-0 pa-0">
            La mejor tasa en créditos digitales: <br />
            {{ credito.tasa.val }}% mensual
          </p>
        </v-banner> -->
      </v-col>
      <v-col v-if="tipoPersona == 2" cols="8" class="ma-0 pa-0 mb-5">
        <br />
        <p class="text-caption text-center grey--text text--darken-2 ma-0 pa-0">
          Recuerda se tomarán $500.00 de tu monto solicitado para ser socio.
        </p>
      </v-col>
    </v-row>
    <v-row justify="center" class="ma-0 pa-0 mt-5">
      <v-col cols="10" class="ma-0 pa-0 d-flex flex-row justify-center">
        <!-- <v-btn
          class="mr-7"
          :loading="cargando"
          :disabled="cargando"
          elevation="2"
          :to="{ name: 'cancelacion' }"
        >
          OBTENER DESPUES
        </v-btn> -->
        <!-- <v-spacer></v-spacer> -->
        <!-- <div style="width: 10%"></div> -->
        <v-btn
          color="primary"
          :loading="cargando"
          :disabled="
            esMontoInputInvalido ||
            credito.monto.val < montoMinimo ||
            credito.monto.val > credito.monto.max
          "
          elevation="3"
          @click="submit"
          >¡Actualizar!<v-icon right light>mdi-arrow-right</v-icon></v-btn
        >
        <!-- </v-col>
      <div style="height: 50px"></div>
      <v-col cols="10" class="ma-0 pa-0 d-flex flex-row justify-center"> -->
        <div style="width: 10%"></div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
// import ControlFrecuencia from '@/components/compartidos/controles_formulario/ControlFrecuencia.vue'
import Credito from '@/servicios/credito'
import { mapActions, mapGetters } from 'vuex'
import {
  ALERTA_ERROR,
  ID_PROCESO_CREDITO_DIGITAL_CONSUMO,
  ID_PRODUCTO_CREDITO_ENLAZAMAS,
} from '@/utilidades/utilidades'
import { FormatoMonedaMixin } from '@/mixins/formateos/FormatoMoneda.mixin'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import { Money } from 'v-money'

export default {
  name: 'ActualizaMontoCredito',
  mixins: [FormatoMonedaMixin, InsertaLogMixin],
  data: () => ({
    moneyInputFocus: false,
    plazoSeleccionado: 0,
    montoMinimo: 5000,
    frecuencia: '',
    plazos: '',
    credito: '',
    montoInput: 0,
    esMontoInputInvalido: false,
    esMontoSujetoAprobar: false,
    money: {
      decimal: '.',
      thousands: ',',
      prefix: '',
      suffix: '',
      precision: 0,
      masked: false,
    },
    montoInputError: '',
    editable: '',
    cargando: false,
    tipoPersona: 1,
    montoPreutorizado: 0,
    storeGetters: {},
    plazosCargados: false,
  }),
  computed: {
    ...mapGetters({
      obtenerPersona: 'persona/obtenerPersona',
    }),
    platzos: function () {
      return this.$store.getters['credito/obtenerPlazos']
    },
  },
  components: {
    Toolbar,
    // ControlFrecuencia,
    Money,
  },
  mounted() {
    //console.log('Mounted')
    this.InsertaLog()
    this.plazos = this.$store.getters['credito/obtenerPlazos']
    this.$forceUpdate()
  },
  created() {
    //console.log('Created')
    //Aqui si lleg
    this.editable = this.$store.getters['credito/obtenerEditable']
    this.credito = this.$store.getters['credito/obtenerCredito']
    this.$store.commit('ESTABLECER_LAYOUT', 'Layout')
    if (this.credito.tipoCredito == ID_PRODUCTO_CREDITO_ENLAZAMAS) {
      this.frecuencia.label = 'Tu retención será de manera:'
    }
    this.plazos = this.$store.getters['credito/obtenerPlazos']
    this.cargarPlazos().then(() => {
      this.plazosCargados = true
    })
    // if (this.plazos.length < 1) {
    //   console.log('Los plazos no se habian cargado')
    //   this.cargarPlazos
    //   console.log(this.plazos) //isra
    // }
    // this.plazos = [
    //   { mask: 'meses', name: '6 meses', title: 'PLAZO', val: 6 },
    //   { mask: 'meses', name: '9 meses', title: 'PLAZO', val: 9 },
    // ]
    this.plazoSeleccionado = this.credito.plazo.val
    //this.plazoSeleccionado = 6
    this.montoInput = this.credito.monto.val
    this.tipoPersona = this.$store.getters['persona/obtenerPersona'].tipoPersona
    this.montoPreutorizado = this.credito.monto.val
  },
  methods: {
    focusInputMoney() {
      // Vue.directive('focus', {
      //   inserted: function (el) {
      //     el.focus()
      //   }
      // })
      // this.$refs.moneyInput.focus()
      this.moneyInputFocus = true
    },
    endChange() {
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
      this.$gtag.event('cambiarMonto', {
        event_category: 'change_in_window',
        event_label: 'Cambia Monto en parametrización',
        value: this.credito.monto.val,
      })
    },
    seleccionarMontoMinimo() {
      this.credito.monto.val = this.montoMinimo
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
    },
    seleccionarMontoMaximo() {
      this.credito.monto.val = this.credito.monto.max
      this.montoInput = this.credito.monto.val
      this.updateMontoPago()
    },
    updateCredito() {
      this.credito.plazo = {
        mask: this.credito.plazo.mask,
        name: this.plazoSeleccionado + this.credito.plazo.mask,
        title: 'PLAZO',
        val: this.plazoSeleccionado,
      }
      this.plazoSeleccionado
      this.$store.credito = this.credito
      this.$store.dispatch('credito/actualizarCredito', this.credito)
      this.$store.dispatch('credito/actualizarPlazos')
    },
    verificarMontoIngresadoEsValido() {
      if (this.montoInput < this.montoMinimo) {
        return
      } else if (this.montoInput > this.credito.monto.max) {
        return
      } else if (this.montoInput % 100 !== 0) {
        return
      } else {
        this.updateMontoPago()
      }
    },
    async updateMontoPago() {
      let result
      try {
        this.cargando = true
        result = await Credito.obtenerPagoSimulado(this.credito)
        if (result.data.Codigo == 200) {
          this.$store.dispatch(
            'credito/actuliazarMontoPago',
            result.data.Modelo
          )
        } else {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
        this.cargando = false
      }
    },
    submit() {
      this.updateCredito()
      console.log(this.$store.getters['personaDocumentos/obtenerDocumentos'])
      if (this.$store.getters['credito/obtenerEditable']) {
        if (
          this.$store.getters['credito/obtenerCredito'].tipoProcesoCredito ==
          ID_PROCESO_CREDITO_DIGITAL_CONSUMO
        ) {
          this.$router.push('cargaDocumentos')
        } else {
          this.$router.push('beneficios')
        }
      } else {
        let documentos =
          this.$store.getters['personaDocumentos/obtenerDocumentos']
        for (let documento of documentos) {
          if (documento.archivoBase64 == '') {
            if (this.$store.getters['credito/obtenerAplicaDevolucionDomicilio'])
              this.$router.push('/datosDomicilio')
            else this.$router.push('/actualizaDocumentos')
            return
          }
        }
        this.$router.push('confirmacion')
      }
    },
    cambiaMontoInput() {
      this.updateCredito()
      this.updateMontoPago()
    },
    cargarPlazos() {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.plazos = this.$store.getters['credito/obtenerPlazos']
          resolve()
        }, 2000)
      })
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
  watch: {
    'credito.monto.val': function (value) {
      this.montoInput = value
    },
    montoInput(value) {
      // console.log(value, this.montoPreutorizado)
      // console.log('mnt inpt wtchr', value)
      this.credito.monto.val = value
      if (value < this.montoMinimo) {
        // Verificar que el monto no sea menor que el minimo pemitido
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'El monto mínimo es de $' + this.montoMinimo
      } else if (value > this.credito.monto.max) {
        // Verificar que el monto no exceda el maximo
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError =
          'El monto máximo es de $' + this.credito.monto.max
      } else if (value % 100 !== 0) {
        // Verificar que el monto sea multiplo de 100
        this.esMontoInputInvalido = true
        this.esMontoSujetoAprobar = false
        this.montoInputError = 'Elige un monto múltiplo de 100'
      } else if (value > this.montoPreutorizado) {
        this.esMontoSujetoAprobar = true
        this.esMontoInputInvalido = false
        this.montoInputError = 'Monto sujeto a aprobación'
      } else {
        this.esMontoSujetoAprobar = false
        this.esMontoInputInvalido = false
        this.credito.monto.val = this.montoInput
        this.montoInputError = ''
      }
    },
  },
  filters: {
    formatoMoneda(valor) {
      return valor.toFixed(2).replace(/[^0-9.-]+/g, '')
    },
  },
}
</script>

<style scoped>
.monto-background {
  background-color: #5e9f42 !important;
  height: 80%;
  width: 80%;
  top: 10px;
  justify-self: center;
  position: absolute;
  border-radius: 100%;
}
.monto-wrapper .v-input__control {
  border: 1px solid #e9e9e9;
  box-shadow: 0px 1px 1px #e9e9e9;
}
.monto-contenido {
  width: 300px;
}
.monto-input {
  font-size: 20px;
  width: 90px;
}
.monto-input:focus,
.monto-input:active,
.monto-input:hover {
  outline: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
